import type { SupportedLanguage, TaskSettings } from '@/app/types';

type LocalizedExample = {
  images: { name: string; url: string }[];
  videos?: { name: string; url: string; coverUrl: string; duration: number }[];
  text: string;
  settings?: TaskSettings;
  thumbnail?: string;
};

export type CompactExample = Partial<Record<SupportedLanguage, LocalizedExample>>;

export const expandExamples = (examples: CompactExample[], locale: SupportedLanguage) => {
  return examples.map((example) => {
    const localizedExample = example[locale] ?? example.en;

    if (!localizedExample) {
      return {
        images: [],
        videos: [],
        text: '',
      };
    }

    return {
      ...localizedExample,
      images: (localizedExample.images || []).map((image) => {
        const imageUrl = image.url;
        return {
          sourceImage: imageUrl,
          sourceImagePreview: imageUrl,
          selectedImage: imageUrl,
          selectedImagePreview: imageUrl,
        };
      }),
      videos: (localizedExample.videos || []).map((video) => ({
        video: video.url,
        videoPreview: video.url,
        coverImage: video.coverUrl,
        coverImagePreview: video.coverUrl,
        duration: video.duration,
      })),
    };
  });
};
